import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { ETaskStatus } from "src/app/models/enums/task-status";
import { BaseDOM } from "../base.dom";
import { IAppareil } from "../iappareil";
import { Canal } from "./canal";
import { EConditionPrelevement } from "./enums/condition-prelevement";
import { EConditionStockage } from "./enums/condition-stockage";
import { EMotifPrelevement } from "./enums/motif-prelevement";
import { ETraitement } from "./enums/traitement";
import { EType } from "./enums/type";
import { ETypeEauRincage } from "./enums/type-eau-rincage";

export class Endoscope extends BaseDOM<Endoscope> implements IAppareil {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    TaskStatus: ETaskStatus = ETaskStatus.New
    @AutoMap()
    ZoneSalle: string = ''
    @AutoMap()
    SamplingDate?: Temporal.PlainDateTime;
    @AutoMap()
    Marque: string = ''
    @AutoMap()
    Modele: string = ''
    @AutoMap()
    NumSerie: string = ''
    @AutoMap()
    NumAppareil: string = ''

    // #region SPECIFIC TO ENDOSCOPE //
    @AutoMap()
    TypeEndoscope: EType = EType.Bronchoscope
    @AutoMap()
    MotifPrelevement: EMotifPrelevement = EMotifPrelevement.AppareilDePret
    @AutoMap()
    Traitement: ETraitement = ETraitement.LDE
    // @AutoMap()
    // CycleTraitement: ECycleTraitement = ECycleTraitement.Complet
    @AutoMap()
    TypeEauRincage: ETypeEauRincage = ETypeEauRincage.EBM
    @AutoMap()
    DateDernierLavage?: Temporal.PlainDateTime

    @AutoMap()
    NumeroESET: string = ''
    @AutoMap()
    DateStockageESET?: Temporal.PlainDateTime
    @AutoMap()
    ConditionPrelevement: EConditionPrelevement = EConditionPrelevement.Autre
    @AutoMap()
    ConditionStockage: EConditionStockage = EConditionStockage.AutreQueESET
    @AutoMap(() => [Canal])
    CanalEndoscopeList: Canal[] = [];
    //#endregion
}